import React, { Suspense, useState } from "react";
import { Await, Navigate } from "react-router";
import CustomLoader from "../controls/CustomLoader";
import { showError } from "../ToastedMessage/ToastedMessage";
import useTitanApp from "../../hooks/useTitanApp";
import AuthorizedModal from "../AuthorizedModal/AuthorizedModal";
import AccessExpiredModal from "../AccessExpiredModal/AccessExpiredModal";
import LottieLoader from "../controls/LottieLoader";
import { useAuth0 } from "@auth0/auth0-react";

const AsyncRendererRouter = ({
  loadingElement,
  isLoading,
  resolve,
  errorElement,
  children,
}) => {
  const [redirectUrl, setRedirectUrl] = useState(null);
  const { appState } = useTitanApp();
  const { isAuthenticated } = useAuth0();

  try {
    if (typeof resolve?.then === "function") {
      resolve?.then((data) => {
        if (data instanceof Response) {
          const toUrl = data?.headers?.get("location") || "/NotFound";
          setRedirectUrl(toUrl);
        }
      });
    }
  } catch (error) {}
  return (
    <Suspense fallback={loadingElement || <LottieLoader />}>
      <Await
        resolve={resolve}
        errorElement={() => {
          if (errorElement) {
            return errorElement;
          }
          showError("Something went wrong.");
          return <></>;
        }}
      >
        {redirectUrl !== null ? (
          <Navigate replace={true} to={redirectUrl} />
        ) : isLoading ? (
          loadingElement || <LottieLoader />
        ) : appState?.isAppLoading === true ? (
          <LottieLoader />
        ) : (
          <>
            {children}

            {isAuthenticated &&
              !isLoading &&
              appState?.isValidOrg === false &&
              !appState?.currentUser && <AccessExpiredModal isOpen={true} />}

            {!isLoading &&
              appState?.isValidOrg === false &&
              appState?.currentUser &&
              !appState?.hasNoTeams && <AuthorizedModal isOpen={true} />}
          </>
        )}
      </Await>
    </Suspense>
  );
};

export default AsyncRendererRouter;
